import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

const StyledTooltip = ({className, ...props}) => (
  <Tooltip {...props} classes= {{tooltip:className}} />
);

const HtmlTooltip = styled(StyledTooltip)(({theme}) => ({
  backgroundColor: "#194f75",
  color: "#194f75",
  maxWidth: 220,
  fontSize: theme.typography.pxToRem(12),
  border: "1px solid #dadde9",
  whiteSpace:"pre-wrap"
}));

// Customer component version for MaterialUI ToolTip
const ToolTip = ({ placement = "left", titleHeading, titleData, children }) => {
  return (
    <HtmlTooltip
      TransitionComponent={Zoom}
      placement={placement}
      title={
        <>
          <div className="data-highlight">
            <h6>{titleHeading}</h6>
            <p>{titleData}</p>
          </div>
        </>
      }
    >
      {children}
    </HtmlTooltip>
  );
};

export default ToolTip;
